module.exports = __webpack_public_path__ + "img/m12.2bec80e3.png";